var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlfabank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alfabank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 17.265H16.145V20H3V17.265ZM6.91 10.81H12.095L12.97 13.56H15.845L11.965 2C11.59 0.89 11.155 0 9.67 0C8.185 0 7.73 0.875 7.34 2L3.28 13.555H5.975L6.91 10.81ZM9.54 3H9.605L11.35 8.5H7.7L9.54 3Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlfabank);
export default __webpack_public_path__ + "static/media/alfabank.c8c1399276fa857d4cc0a507cc2221f3.svg";
export { ForwardRef as ReactComponent };